import { Box } from '@hivebrite/design-system/Box';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import SuccessCircleCheck from 'hb-react/shared/icons/SuccessCircleCheck';

import { getSize } from './utils';
import Landing from '../Landing';

const EndOfFeed = () => {
  const breakpoint = useBreakpoint();
  const size = getSize(breakpoint);

  const groupTabName = usePageMenuName(PAGES.TOPICS, __('groups'));

  return (
    <Landing
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      px={0}
      pt={{ _: 4, m: 2 }}
      pb={{ _: 4, m: 2, l: '18px' }}
    >
      <Box p={{ _: '1.75px', l: '2.25px' }}>
        <SuccessCircleCheck width={size} height={size} />
      </Box>
      <Box font="h3-semibold" mt={{ _: 2, l: '7px' }}>
        {s__('LiveFeed|You are all caught up')}
      </Box>
      <Box mt="6px">
        {s__(
          'LiveFeed|You have read all new posts in your %{groupsTabName}',
        ).i__({ groupsTabName: groupTabName })}
      </Box>
    </Landing>
  );
};

export default EndOfFeed;
